import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/mapaAN/step2';
import { CTRL_175 } from '../../../validators/175/ctrl175';
import { CTRL_176 } from '../../../validators/176/ctrl176';
import { MapaANControlNames } from '../../rectificatif/services/mapaANControleNames';
import { TypeVoie } from '../models/TypeVoie';
@Component({
  selector: 'app-type-voie',
  templateUrl: './type-voie.component.html'
})
export class TypeVoieComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeVoie'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() voie: TypeVoie;
  @Input() rule : string;
  @Input() errorMessage : string;

  public step2 = new Step2();

  public rg1 = CTRL_176.id + '_1';
  public rg2 = CTRL_175.id + '_1';
  
  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaANControlNames.getCtrl_176Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaANControlNames.getCtrl_175Names_json() }));
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
		return this.uid.substring(0, this.uid.indexOf("SepSep"));
	}

}

